import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landprocurement',
  templateUrl: './landprocurement.component.html',
  styleUrls: ['./landprocurement.component.css']
})
export class LandprocurementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landprocurement/landprocurement.component.ts